import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CheckoutStepService } from "@spartacus/checkout/base/components";
import { ActiveCartFacade } from "@spartacus/cart/base/root";
import { RoutingConfigService } from "@spartacus/core";
import { switchMap, take } from "rxjs/operators";
import { GenCheckoutService } from "../services/checkout.service";
import { GenHandlingOption } from "../models/cart.model";
import { UserAccountFacade } from '@spartacus/user/account/root';

@Injectable({
  providedIn: 'root'
})
export class GenSpecialHandlingGuard implements CanActivate {
  constructor(
      protected checkoutStepService: CheckoutStepService,
      protected activeCartFacade: ActiveCartFacade,
      protected router: Router,
      protected routingConfigService: RoutingConfigService,
      protected checkoutService: GenCheckoutService,
      protected userAccount: UserAccountFacade,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.activeCartFacade.getActive().pipe(
      take(1),
      switchMap((cart) => this.userAccount.get().pipe(
        switchMap(user => this.checkoutService.getSpecialHandlingOptions((cart).code, user?.uid, cart?.shippingGroups?.[0]?.shippingGroupName))
      )),
      switchMap((options: GenHandlingOption[]) => {
        if (options.length) {
          return of(true);
        }

        return this.checkoutStepService.activeStepIndex$.pipe(
          take(1),
          switchMap((step: number) => {
            switch (step) {
              case 0: return of(this.getUrl('checkoutPaymentType'));
              default: return of(this.getUrl('checkoutDeliveryAddress'));
            }
          })
        );
      }),
    );
  }

  protected getUrl(routeName: string): UrlTree {
    return this.router.parseUrl(
        this.routingConfigService.getRouteConfig(routeName)?.paths?.[0] as string
    );
  }
}
